import _ from 'lodash';
import { currency } from 'Helpers/Formats';

const getTooltip = resource => `
${resource.attr('label')} - ${currency(
  parseFloat(resource.attr('value')),
  false,
)}

Percentage of Portfolio - ${resource.attr('percentageValue')}`;

export const getChartData = (portfolio, selectedCategory, withTooltip) => {
  return _(portfolio?.attr('categoryChartData'))
    .toArray()
    .orderBy(a => parseFloat(a.attr('percentageValue')), ['desc'])
    .map((resource) => {
      const label = resource.attr('label');
      const id = resource.id();
      const type = resource.attr('type');
      const color = resource.attr('color');
      const percentageValue = resource.attr('percentageValue');

      return {
        tooltip: withTooltip ? getTooltip(resource) : null,
        value: resource.attr('value'),
        color,
        type,
        label,
        id,
        percentageValue,
      };
    })
    .value();
};

export const getCategoryIDToCategoryMap = (portfolio, selectedCategory) => {
  return new Map(getChartData(portfolio, selectedCategory).map(c => [c.id, c]));
};
